import { render, staticRenderFns } from "./IMAnouncement.vue?vue&type=template&id=011d9696&lang=pug"
import script from "./IMAnouncement.vue?vue&type=script&lang=js"
export * from "./IMAnouncement.vue?vue&type=script&lang=js"
import style0 from "./IMAnouncement.vue?vue&type=style&index=0&id=011d9696&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports